import { render, staticRenderFns } from "./CommunityGallery.vue?vue&type=template&id=6ce21c44"
import script from "./CommunityGallery.vue?vue&type=script&lang=ts"
export * from "./CommunityGallery.vue?vue&type=script&lang=ts"
import style0 from "./CommunityGallery.vue?vue&type=style&index=0&id=6ce21c44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports